import { Tooltip } from "@mui/material";
import logoutIcon from "@user/assets/images/common/log-out.svg";
import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import { useAuthStore } from "@user/store/auth_store";

import router from "@user/router";

function Header() {
  const userName = useAuthStore((state) => state.userName);
  const role = useAuthStore((state) => state.role);
  const ip = useAuthStore((state) => state.ip);
  const loginTime = useAuthStore((state) => state.loginTime);

  return (
    <>
      {/* header */}
      <div className="header">
        <h1 onClick={() => router.navigateByPath("/")}>K-WMS</h1>
        <div className="util">
          <div>
            <i></i>
            <span>
              <b>{ userName }({ commonCode.getCodeValue("userAuth", role)})</b>
              님 접속하셨습니다
            </span>
            <div className="divider ver"></div>
            <span>
              접속 IP :
              { ip }
            </span>
            <div className="divider ver"></div>
            <span>
              최근 접속일 :
              { kutil.date2string(loginTime, "yyyy-MM-dd HH:mm:ss") }
            </span>
          </div>
          <Tooltip title="로그아웃">
            <button><img src={logoutIcon} alt="로그아웃" onClick={() => useAuthStore.getState().logout()} /></button>
          </Tooltip>
        </div>
      </div>
      {/* //header */}
    </>
  );
}

export default Header;
